import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid';
// import ProjectList from './ProjectList';
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firestoreConnect, isLoaded } from 'react-redux-firebase'
import { Redirect } from 'react-router-dom'

import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Projects from '../projects/Projects';
import Tasks from '../projects/tasks/Tasks';
import Loader from '../../components/custom/loader'


class UserDashboard extends Component {

  state = {
    activeTab: 0
  }


  render() {
    const { user = {}, auth = {}, userId, users } = this.props;
    const { activeTab } = this.state;

    if (!auth.uid) return <Redirect to='/signin' />

    if (!isLoaded(users)) {
      return <Loader />
    }

    return (
      <div>
        <Paper square>
          <Tabs
            value={activeTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={(tab, val) => { this.setState({ activeTab: val }) }}
          >
            <Tab label={`Projects`} />
            <Tab label={`Tasks`} />
          </Tabs>
          <TabPanel value={activeTab} index={0}>
            <Projects user={user} />
          </TabPanel>
          <TabPanel value={activeTab} index={1}>
            <Tasks user={user} />
          </TabPanel>
        </Paper>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const userId = ownProps.match.params.userId
  const users = state.firestore.data.users || [];

  return {
    user: users[userId] || {},
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    users:state.firestore.data.users,
    userId
  }
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    if (props.userId) {
      return [
        {
          collection: 'users',
          doc: props.userId,
        }
      ]
    } else {
      return []
    }
  })
)(UserDashboard)



function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box style={{ minHeight: 'calc(100vh - 168px)', background: 'rgba(0,0,0,.08)' }} p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};